module.exports = __webpack_public_path__ + "static/media/info-deep-blue.80dfa46a.svg";